// @ts-nocheck
import axios from "axios"
import endpoints from '../../config/endpoints.config'

const login = async (username: string, password: string) => {
    return await axios(endpoints.auth.login, {
        method: 'post',
        data: {
            // body
            username,
            password
        },
        headers: {
            'content-type': 'application/json',
            // 'Access-Control-Allow-Origin': '*'
        },
        // TODO: must be set to true in PROD
        withCredentials: false
    })

}

export default login